import { render } from "./Message.vue?vue&type=template&id=378d13c7&ts=true&lang=pug"
import script from "./Message.vue?vue&type=script&setup=true&lang=ts"
export * from "./Message.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__